'use client';

import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

const ManufacturesWarranty = () => {
  const t = useTranslations();

  return (
    <section>
      <LayoutGrid className="pt-20">
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <TypographyV3
            Element="h4"
            variant="unset"
            className="mb-14 text-center text-[26px] leading-[31px] md:text-[40px] md:leading-[48px]"
          >
            {t('extend_section_header3')}
          </TypographyV3>
        </GridItem>
        <GridItem
          colEnd={{ sm: 'main', md: 'main', lg: 22 }}
          colStart={{ sm: 'main', md: 'main', lg: 4 }}
        >
          <TypographyV3 className="text-center">
            {t('extend_section_header4')}
          </TypographyV3>
        </GridItem>
        <GridItem
          colEnd={{ sm: 'main' }}
          colStart={{ sm: 'main' }}
          className="pt-20"
        >
          <div className="border-b border-gray-400" />
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default ManufacturesWarranty;
